import { View, ViewModel } from "..";
import { Prototype, PrototypeCreator } from "./prototype/prototypeCreator";

export class ViewGenerator{
    public static GetHtml(view:View<ViewModel>):Element{
        if(view instanceof HTMLElement)
            return view;
        let prototype = PrototypeCreator.GetPrototype(view);
        let result =<Element> prototype.create(view);
        view.firstlevelElement = result;
        view.onRenderCompleted();
        return result;
    }
    public static CreatePrototype(html:string,rootId:string = null){
        let prototype = PrototypeCreator.createPrototype(html,rootId);
        return prototype;
    }
    public static CreateFromPrototypeAndViewModel(prototype:Prototype,viewModel:ViewModel):Element{
        let result=<Element> prototype.createFromIndex(viewModel,0);
        return result;
    }
    public static GetNodeByTemplate(viewModel:ViewModel,templateNode:Node):Element{
        if(templateNode==null)
            return null;
        let prototype = <Prototype>((<any>templateNode).__BinderPrototype__)
        let result=<Element> prototype.createFromTemplateNode(viewModel,templateNode);
        return result;
    }
}